import { render } from "./Book.vue?vue&type=template&id=138cfb36&scoped=true"
import script from "./Book.vue?vue&type=script&lang=ts"
export * from "./Book.vue?vue&type=script&lang=ts"

import "./Book.vue?vue&type=style&index=0&id=138cfb36&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-138cfb36"

export default script